import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { FormikErrors } from 'formik';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../../api';
import { AppState } from '../../../../../../store/models/app-state';
import { CustomerConditions } from '../models/customer-conditions';
import { CustomerConditionsFormValues } from '../models/customer-conditions-form-values';
import { SaveResult } from '../../../../../../common/models/save-result';
import { customerConditionsRequestSelector } from './customer-conditions-selectors';
import { updateCustomerMember } from '../../store/customer-detail-actions';

export const CUSTOMER_CONDITIONS_UPDATE = 'CUSTOMER_CONDITIONS_UPDATE';
export const CUSTOMER_CONDITIONS_SAVE = 'CUSTOMER_CONDITIONS_SAVE';
export const CUSTOMER_CONDITIONS_REQUEST = 'CUSTOMER_CONDITIONS_REQUEST';
export const CUSTOMER_CONDITIONS_RECEIVED = 'CUSTOMER_CONDITIONS_RECEIVED';

const receiveCustomerConditions = (conditions: CustomerConditions) => {
    return {
        type: CUSTOMER_CONDITIONS_RECEIVED,
        conditions,
    };
};

export const updateCustomerConditions = (
    formData: CustomerConditionsFormValues,
    isDirty: boolean,
    isValid: boolean,
    errors: FormikErrors<CustomerConditionsFormValues>
) => {
    return {
        type: CUSTOMER_CONDITIONS_UPDATE,
        formData,
        isDirty,
        isValid,
        errors,
    };
};

export const fetchCustomerConditions = () => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        const customerId = getState().contactsAndOrganizations.customers.customerDetail.overview.customer?.id;
        if (!customerId) {
            return;
        }

        dispatch({ type: CUSTOMER_CONDITIONS_REQUEST });

        const response = await api.contactsAndOrganizations.Customer.CustomerDetail.Conditions.getConditions(
            customerId
        );

        if (response.success) {
            dispatch(receiveCustomerConditions(response.result));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const saveConditions = () => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        const state = getState();
        const customerId = getState().contactsAndOrganizations.customers.customerDetail.overview.customer?.id;
        const employeeRequest = customerConditionsRequestSelector(state);
        if (!customerId || !employeeRequest) {
            return SaveResult.Error;
        }

        dispatch({ type: CUSTOMER_CONDITIONS_SAVE });
        const response = await api.contactsAndOrganizations.Customer.CustomerDetail.Conditions.updateConditions(
            customerId,
            employeeRequest
        );

        if (response.success) {
            dispatch(updateCustomerMember(employeeRequest.isMember, employeeRequest.memberSince));
            dispatch(receiveCustomerConditions(response.result));
            return SaveResult.Success;
        }
        return SaveResult.Error;
    };
};
